export enum AuthRoutes {
  blank = '/',
  dashboard = '/dashboard',
  renewals = '/renewals',
  reports = '/reports',
  auditLog = '/audit-log',
  profile = '/profile',
  account = '/account',
  productDivisions = '/divisions',
  products = '/products-list',
  tenantStatuses = '/tenant-statuses',
  subscriptionStatuses = '/subscription-statuses',
  paymentStatuses = '/payment-statuses',
  billingCycles = '/billing-cycles',
  currencies = '/currencies',
  productMaster = '/products',
  countries = '/countries',
  timezones = '/timezones',
  categories = '/categories',
  roles = '/roles',
  configKeys = '/config-keys',
  notifTemplates = '/notification-templates',
  receiptTemplates = '/receipt-templates',
  plans = '/plans',
  globalConfig = '/global-config',
  branding = '/branding',
  internalUsers = '/internal-users',
  accessReviews = '/access-reviews',
  tenantUsers = '/tenant-users',
  subscriptions = '/subscriptions',
  payments = '/payments',
  featureFlags = '/feature-flags',
  notificationsOutbox = '/notifications/outbox',
  dataManagement = '/data-management',
  dsar = '/dsar',
}

export enum RouteParamsTypes {
  any = '/*',
  id = '/:id',
  blank = '',
  add = '/add',
  edit = '/edit',
  view = '/view',
  list = '/list',
}

export enum Modules {
  auth = '/auth',
  home = '/home',
  error = '/error',
  my = '/my',
  products = '/products',
  masters = '/masters',
  system = '/system',
  iam = '/iam',
  tenants = '/tenants',
}

export enum NonAuthRoutes {
  login = '/login',
  mfaVerify = '/mfa-verify',
  forbidden = '/forbidden',
  unHandledRejection = '/server-error',
  notFound = '/page-not-found',
  tenantInvalid = '/tenant-invalid',
  activate = '/activate',
  activateTenantUser = '/activate-tenant-user/:token',
}

export enum PermissionActionsEnum {
  View = 'view',
  Add = 'add',
  Update = 'update',
  Delete = 'delete',
  Email = 'email',
  Export = 'export',
  Import = 'import',
}

export enum PermissionModulesEnum {
  Dashboard = 'dashboard',
  ProductDivisions = 'product_divisions',
  Products = 'products',
  Masters = 'masters',
}

export enum SortOrder {
  asc = 'ASC',
  desc = 'DESC',
}

export enum RowClassName {
  even = 'even',
  odd = 'odd',
}

export enum RoleCodes {
  system_admin = 'system_admin',
  admin = 'admin',
  manager = 'manager',
}
